import React, { createContext, useEffect, useState, useContext } from 'react';
import { data } from 'react-router';

const MetaContext = createContext();

export const useMeta = () => useContext(MetaContext);

export const MetaProvider = ({ children }) => {
  const [meta, setMeta] = useState({
    title: 'Takeaya',
    description: 'Default description for Takeaya.',
    keywords: '',
    image_url: '',
  });

  useEffect(() => {
  fetch('https://admin.takeaya.com/api/admin/meta')
    .then(res => res.json())
    .then(response => {
      const metaData = response.data;
      setMeta({
        title: metaData.title,
        description: metaData.description,
        keywords: metaData.keywords,
        image_url: metaData.image_url,
      });

      console.log('Meta state updated:', metaData); // Add this line too
    })
    .catch(err => console.error("Failed to fetch meta:", err));
}, []);


  return (
    <MetaContext.Provider value={meta}>
      {children}
    </MetaContext.Provider>
  );
};